var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833496 10C2.27516 6.34167 5.8335 3.75 10.0002 3.75C14.1668 3.75 17.7252 6.34167 19.1668 10C17.7252 13.6583 14.1668 16.25 10.0002 16.25C5.8335 16.25 2.27516 13.6583 0.833496 10ZM17.3501 10C15.9751 7.19167 13.1585 5.41667 10.0001 5.41667C6.8418 5.41667 4.02513 7.19167 2.65013 10C4.02513 12.8083 6.8418 14.5833 10.0001 14.5833C13.1585 14.5833 15.9751 12.8083 17.3501 10ZM10.0002 7.91667C11.1502 7.91667 12.0835 8.85 12.0835 10C12.0835 11.15 11.1502 12.0833 10.0002 12.0833C8.85016 12.0833 7.91683 11.15 7.91683 10C7.91683 8.85 8.85016 7.91667 10.0002 7.91667ZM6.25016 10C6.25016 7.93333 7.9335 6.25 10.0002 6.25C12.0668 6.25 13.7502 7.93333 13.7502 10C13.7502 12.0667 12.0668 13.75 10.0002 13.75C7.9335 13.75 6.25016 12.0667 6.25016 10Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.a8ccfbf3.svg";
export { ForwardRef as ReactComponent };